import { useThrottleFn } from 'ahooks'

import { sa } from '../helpers/sa'

import type { FullTrackEventParamsInput } from '@loc/server/interface/track/trackEventParams.common'
import type { ITrackCoreProps } from '.'
import type { ICoreItem, TrackCoreEventProps } from './type'


import { useRef, useEffect } from 'react';
export const useDefaultTrack = ({
  eventTracking,
}: ITrackCoreProps): ICoreItem<TrackCoreEventProps> => {
  const pendingQueue = useRef<FullTrackEventParamsInput[]>([])

  // 节流函数：处理批量上报
  const { run: throttleRun } = useThrottleFn(
    async () => {
      if (pendingQueue.current.length === 0) return

      const eventsToSend = [...pendingQueue.current]
      pendingQueue.current = []

      await eventTracking(eventsToSend)
    },
    {
      wait: 4000,
    },
  )

  // 组件卸载时清理
  useEffect(() => {
    return () => {
      // 立即发送剩余事件
      if (pendingQueue.current.length > 0) {
        const remainingEvents = [...pendingQueue.current]
        pendingQueue.current = []
        eventTracking(remainingEvents)
      }
    }
  }, [eventTracking])

  const trackEvent = async (props: TrackCoreEventProps) => {
    const { commonParamsLatest, ...rest } = props
    const eventName = rest.name
    const processedParams: FullTrackEventParamsInput = {
      ...rest,
      ...commonParamsLatest.commonParams,
    }

    // 立即发送给第三方分析工具（如Google Analytics）
    sa.track(eventName, { ...rest, ...commonParamsLatest.gaCommonParams })

    // 事件加入队列，触发节流上报
    pendingQueue.current.push(processedParams)
    await throttleRun()
  }

  return { trackEvent }
}
